import React from 'react';

const IconButton = ({ Icon, onClick, spin = false, title, fixedWidth = false }) => (
  <div className="btn px-1" onClick={onClick}>
    <Icon spin={spin} title={title} fixedWidth={fixedWidth} />
  </div>
);

export default IconButton;
